// 支付结算的 接口集合
import request from '../request.js'

// 创建会员 ---- 李开明
export const setCompanyMember = function (data) {
    return request({
        url: 'bmPayment/setCompanyMember',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

// 设置企业信息 ---- 李开明
export const setCompanyInfo = function (data) {
    return request({
        url: 'bmPayment/setCompanyInfo',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

// 发送短信验证码 ---- 李开明
export const sendVerificationCode = function (data) {
    return request({
        url: 'bmPayment/sendVerificationCode',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

// 绑定手机号 ---- 李开明
export const bindPhone = function (data) {
    return request({
        url: 'bmPayment/bindPhone',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

// 获取企业信息中的缓存中的审核结果 ---- 李开明
export const getApplyRecordResult = function (data) {
    return request({
        url: 'bmPayment/getApplyRecordResult',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

// 保存收付款账号 ---- 李开明
export const saveAccount = function (data) {
    return request({
        url: 'bmPayment/saveAccount',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

// 获取当前用户信息 ---- 李开明
export const selectDeptByUserId = function (data) {
    return request({
        url: 'sysDept/selectDeptByUserId',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

// 保存通联接口调用记录 ---- 李开明
export const saveApplyRecord = function (data) {
    return request({
        url: 'bmPayment/saveApplyRecord',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

// 设置通联接口调用记录 ---- 李开明
export const setApplyRecord = function (data) {
    return request({
        url: 'bmPayment/setApplyRecord',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

// 影印件上传 ---- 李开明
export const pictureCollect = function (data) {
    return request({
        url: 'bmPayment/pictureCollect',
        method: 'post',
        headers: {
            'Content-type': 'multipart/form-data'
        },
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

// 电子签约 ---- 李开明
export const signContract = function (data) {
    return request({
        url: 'bmPayment/signContract',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

// 查询信息 ---- 李开明
export const accountVerify = function (data) {
    return request({
        url: 'bmPayment/accountVerify',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        headers: {
            'Content-Type': 'application/json'
        },
        transformRequest: [function (data, headers) {
            delete headers.token
            return JSON.stringify(data)
        }],
        data
    })
}

// 支付流水列表 ---- 刘献根
export const selectPayDetailAll = function (data) {
    return request({
        url: 'bmPayment/selectOperatePayBillAll',
        method: 'post',
        data
    })
}

// 提现记录列表 ---- 刘献根
export const selectWithdrawRecord = function (data) {
    return request({
        url: 'bmPayment/selectWithdrawRecord',
        method: 'post',
        data
    })
}

// 支付会员列表回显---- 郑智慧
export const selectAllPage = function (data) {
    return request({
        url: 'bmPayment/selectAllPage',
        method: 'post',
        data
    })
}

// 支付会员详情---- 郑智慧
export const getDetails = function (data) {
    return request({
        url: 'bmPayment/getDetails',
        method: 'post',
        data
    })
}

// 支付会员银行卡详情---- 郑智慧
export const getBankInfo = function (data) {
    return request({
        url: 'bmPayment/getBankInfo',
        method: 'post',
        data
    })
}

// 获取支付流水的详情---- 刘献根
export const getPayBillDetail = function (data) {
    return request({
        url: '/bmPayment/getPayBillDetail',
        method: 'post',
        data
    })
}

// 能公社运营项目-平台账户-回显平台账户---- 李开明
export const platformMemberInfoEcho = function (data) {
    return request({
        url: 'bmPayment/getPlatformMember',
        method: 'post',
        data
    })
}


/****** 托收代付  ****/
// 能工社运营托管代收列表查询 ---- 叶凡
export const getCollectPages = function (data) {
    return request({
        url: 'bmPayment/getCollectPages',
        method: 'post',
        data,
        requestConfig: {
            hideLoading: true
        }
    })
}
// 能工社运营托管代收详情页 ---- 叶凡
export const getCollectDetail = function (data) {
    return request({
        url: 'bmPayment/getCollectDetail',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}
// 托管代付提交确认---- 叶凡
export const escrowApply = function (data) {
    return request({
        url: 'bmPayment/escrowApply',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}
// 能工社运营托管代付详情 ---- 叶凡
export const escrowInfo = function (data) {
    return request({
        url: 'bmPayment/escrowInfo',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}
// 退款提交确认---- 叶凡
export const refundApply = function (data) {
    return request({
        url: 'bmPayment/refundApply',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}
// 能工社运营获取退款详情---- 叶凡
export const refundInfo = function (data) {
    return request({
        url: 'bmPayment/refundInfo',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}
// 托管代付申请页信息查询---- 叶凡
export const escrowApplyInfo = function (data) {
    return request({
        url: 'bmPayment/escrowApplyInfo',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}
